// extracted by mini-css-extract-plugin
var _1 = "VA2h0";
var _2 = "Mv28L";
export { _1 as "badgeStyle", _2 as "hideCountStyle" }
